import React, { useEffect, useRef, useState } from "react";
import NavigationBar from "../../ReusableComp/NavigationBar";
import NavBarLeft from "../../ReusableComp/NavBarLeft";
import Select from "../../ReusableComp/Select";
import axios from "../../../axios-interceptor";
import { base_url } from "../../../utilities";
import moment from "moment/moment";
import PopUpModal from "../../ReusableComp/PopUpModal";
import { Offcanvas } from "react-bootstrap";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router";
import Pagination from "../PMS_Study_Details/Pagination";
import Loader from "../../ReusableComp/Loader";

const PMSSiteDetails = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if(!localStorage.getItem("login_user_name")){
        navigate("/");
    }
}, []);
  const handleClosePopup = () => {
    setOpen(false);
    handleDiscard()
    window.location.reload();
  };
  const handleCloseModal = () => setShow(false);
  const [open, setOpen] = useState(false);
  const [getAllSites, setGetAllSites] = useState([]);
  const [allSitesAddresses, setAllSitesAddresses] = useState([]);
  const [listOfZones, setListOfZones] = useState([]);
  const [statesByZone, setStatesByZone] = useState([]);
  const [citiesByState, setCitiesByState] = useState([]);
  const [zoneId, setNewZoneId] = useState("");
  const [stateId, setNewStateId] = useState("");
  const [newCityId, setNewCityId] = useState("");
  const [zoneData, setZoneData] = useState("");
  const [btnFlag, setBtnFlag] = useState(false)
  let [loading_flag, setLoading_flag] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [filteredStudies, setFilteredStudies] = useState([]);
  useEffect(() => {
    // =======all Zones============
  
setLoading_flag(true)
    axios
      .post(base_url + "zones/get_all_zones")
      .then((res) => {
        setZoneData(res.data.data);
        setListOfZones(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    setLoading_flag(true);
    axios
      .post(base_url + "sites/get_all_sites")
      .then((res) => {
        let data = res?.data?.data?.map((ele) => {
          ele.is_selected = false;
          return ele;
        });
        setGetAllSites(data);
        setDataCards(data)
        setAllSitesAddresses(data);
        setLoading_flag(false);
      })
      .catch((err) => {
        console.log(err);
      });
     
      
  }, []);
  const zone_options = listOfZones?.map((zone) => ({
    value: zone.zone_id,
    label: zone.zone_name,
  }));
  const state_options = statesByZone?.map((state) => ({
    value: state.state_id,
    label: state.state_name,
  }));
  const city_options = citiesByState?.map((city) => ({
    value: city.city_id,
    label: city.city_name,
  }));

  const [dataCards, setDataCards] = useState([])
  const [allStateCards, setAllStateCards] = useState([])
  const [citiesCards, setCitiesCards] = useState([])
  const handleReviewActions = () => {
    setOpen(false);
    handleDiscard()
    window.location.reload();
  }
  const handleSelectZone = (event, optionValue, optionKey) => {
    setCurrentPagePagination(1)
    setFilterLength(false)
    setNewZoneId(optionKey);
    setDefaultSelect(false);
    if (optionValue === "All Zones") {
      setGetAllSites(allSitesAddresses);
      setStatesByZone([]);
      setCitiesByState([]);
      setDataCards(allSitesAddresses)
      let filteredCardData = getAllSites?.filter((i) => {
        
          if(i.site_name.toLowerCase().includes(searchText.toLowerCase())){
            return i;
          }
        
      }

      );
     

      if (!btnFlag) {
        setFilteredStudies(filteredCardData)
      }
    }
    else {
      let filteredCardData = getAllSites?.filter((i) => {
        if (i.zone_id === optionKey) {
          if(i.site_name.toLowerCase().includes(searchText.toLowerCase())){
            return i;
          }
        }
      }

      );
      if(filteredCardData?.length===0){
        setFilterLength(true)
      }

      if (!btnFlag) {
        setDataCards(filteredCardData);
        setAllStateCards(filteredCardData);
        setFilteredStudies(filteredCardData)
      }

      axios
        .post(base_url + "states/get_states_by_zone", {
          zone_id: optionKey,
        })
        .then((res) => {
          setStatesByZone(res.data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    setFilterLength(true)
  };

  // ==========States========

  const handleStateOptionSelect = (event, optionValue, optionKey) => {
    setCurrentPagePagination(1)
    setFilterLength(false)
    setNewStateId(optionKey);
    setDefaultSelect(false);
    if (optionValue === "All States") {
      setDataCards(allStateCards);
      setCitiesByState([]);
      let filteredCardData = allStateCards?.filter((i) => {
        
        if(i.site_name.toLowerCase().includes(searchText.toLowerCase())){
          return i;
        }
      
    }

    );
    if (!btnFlag) {
      setFilteredStudies(filteredCardData)
    }
  } else {
    let filteredCardData = getAllSites.filter((i) => {
      if (i.state_id === optionKey) {
        if(i.site_name.toLowerCase().includes(searchText.toLowerCase())){
          return i;
        }
      }
    });
    if(filteredCardData?.length===0){
      setFilterLength(true)
    }
    if (!btnFlag) {
        setDataCards(filteredCardData);
        setCitiesCards(filteredCardData);
        setFilteredStudies(filteredCardData)
      }
      axios
        .post(base_url + "cities/get_cities_by_state", {
          state_id: optionKey,
        })
        .then((res) => {
          setCitiesByState(res.data.data);
          
        })
        .catch((err) => {
          console.log(err);
        });
    }
    setFilterLength(true)
    
  };

  const handleCityOptionSelect = (event, optionValue, optionKey) => {
    setCurrentPagePagination(1)
    setNewCityId(optionKey);
    if (optionValue === "All Cities") {
      setDataCards(citiesCards)
      let filteredCardData = citiesCards?.filter((i) => {
        
        if(i.site_name.toLowerCase().includes(searchText.toLowerCase())){
          return i;
        }
      
    }

    );

    if (!btnFlag) {
      setFilteredStudies(filteredCardData)
    }
    } else {
      let filteredCardData = getAllSites?.filter((i) => {
        if (i.city_id === optionKey) {
          if(i.site_name.toLowerCase().includes(searchText.toLowerCase())){
            return i;
          }
        }
      });
      if(filteredCardData?.length===0){
        setFilterLength(true)
      }
      if (!btnFlag) {
        setFilteredStudies(filteredCardData)
        setDataCards(filteredCardData);
      }
    }
  };

  const [phoneNo, setPhoneNo] = useState("");
  const [siteAdd, setSiteAdd] = useState("");
  const [siteName, setSiteName] = useState("");
  const [siteLocation, setSiteLocation] = useState("");
  const [sitePinCode, setSitePinCode] = useState("");
  const [pinCodeError, setPinCodeError] = useState("");

  useEffect(() => {
    setLoading_flag(true)
    if(getAllSites != null){
      setFilteredStudies(getAllSites)
      setLoading_flag(false)
    }
  
    },[getAllSites])
    const [filterLength,setFilterLength] = useState(false)

    
  const handleSearchData = (e) => {
    setDefaultSelect(true)
    setCurrentPage1(1);
    const searchText = e.target.value;
    setSearchText(searchText);
    const filterStudies = getAllSites?.filter((card) =>
      card.site_name.toLowerCase().includes(searchText.toLowerCase())
    );
    
    setFilteredStudies(filterStudies);
    if(filterStudies.length===0){
      setFilterLength(true)
    }else{
      setFilterLength(false)

    }
  };
 

  const handleInputeSiteDetails = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    const regex3 = /^[\d\-\/]+$/

    if (name === "phone_no") {
      if (regex3.test(value) || value === '') {
      setPhoneNo(value);
      }
    }
    if (name === "site_add") {
      setSiteAdd(value);
    }
    if (name === "site_name") {
      setSiteName(value);
    }
    if (name === "location"){
      setSiteLocation(value)
    }
    if(name === "pin_code"){
      setSitePinCode(value.length>6?value.slice(0,6):value)

      const pinCodePattern = /^\d{6}$/;

        if (value.length >=6) {
         
          setPinCodeError("");
        } else {
        
          setPinCodeError("Please enter a valid 6-digit PIN code.");
        }
          }
  };

  const createNewSite = () => {
    axios
      .post(base_url + "sites/site_creation", {
        zone_id: zoneId,
        state_id: stateId,
        city_id: newCityId,
        site_name: siteName,
        site_address: siteAdd,
        phone_number: phoneNo,
        location : siteLocation,
        pincode:sitePinCode,
        created_by: localStorage.getItem('login_user_name')
      })
      .then((res) => {
        if (res.data.message == "Error while creating a site") {
          if(res.data.data == "Validation error"){
            toast.error("This site has already been created with the given site name and location.", {
              toastId: 1
            }
            
            )

          }
          else{
            let originalString = res.data.data;
            let trimmedString = originalString.substring(0, originalString.indexOf(" at"));

            toast.error(trimmedString, {
              toastId: 1
            }   )
          }

        }
        if(res.data.message === "Site created successfully") {
          setOpen(true);
          handleDiscard()
        }
        // ==================== need to add check email ==============
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const [defaultSelect, setDefaultSelect] = useState(false);

  const handleClearFilters = () => {
    setDefaultSelect(true);
    setStatesByZone([]);
    setCitiesByState([]);
    setSearchText("")
    setGetAllSites(allSitesAddresses)
    setDataCards(getAllSites)
    const filteredStudies = getAllSites?.filter((card) =>
      card.site_name.toLowerCase().includes("")
    );
    
    setFilteredStudies(filteredStudies);
    
  };
const handleOnExit=()=>{
  handleDiscard()
  handleClearFilters()
}
  const handleDiscard = () => {
    setBtnFlag(false)
    setStatesByZone([]);
    setCitiesByState([]);
    handleCloseModal();
    setPhoneNo("");
    setSiteAdd("");
    setSiteName("");
    setNewZoneId("");
    setNewStateId("");
    setNewCityId("");
    setSitePinCode("")
  };

  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const [siteAddress, setSiteAddress] = useState();
  const [siteMobile, setSiteMobile] = useState();
  const [siteId, setSiteId] = useState("");
  const [isSelected, setIsSelected] = useState();

  const handleEditCard = (data) => {
    const filter = getAllSites.map((i) => {
      if (i.site_id === data.site_id) {
        i.is_selected = true;
        setSiteAddress(i.site_address);
        setSiteMobile(i.phone_number);
        setSiteId(i.site_id);
        setIsSelected(i.is_selected);
      }else{
 i.is_selected = false;
}
      return i;
    });
    setGetAllSites(filter);
  }
  const handleCancelEdit = (data) => {
    const cancelled = getAllSites.map((i) => {
      if (i.site_id === data.site_id) i.is_selected = false;
      return i;
    });
    setGetAllSites(cancelled);
  };






  const [siteAddressInputRef, setSiteAddressInputRef] = useState(false)
  const [siteMobileInputRef, setSiteMobileInputRef] = useState(false)
  
// ==================Pagination=======================
  const [currentPage1, setCurrentPage1] = useState(1);
   const [postsPerPage] = useState(6);
   const indexOfLastPost = currentPage1 * postsPerPage;
   const indexOfFirstPost = indexOfLastPost - postsPerPage;
   const cardsToDisplay = dataCards.slice(indexOfFirstPost, indexOfLastPost);

 
   const paginate = (pageNumber) => {
      
      setCurrentPage1(pageNumber);
   };

   const previousPage = () => {
    if (currentPage1 !== 1) {
       setCurrentPage1(currentPage1 - 1);
       
    }
 };

 const nextPage = () => {
    if (currentPage1 !== Math.ceil(filteredStudies?.length / postsPerPage)) {
       setCurrentPage1(currentPage1 + 1);
    }
 };


// ====================================
  function Card({ data }) {
    const [isEditing, setIsEditing] = useState(false);
    const [siteAddress, setSiteAddress] = useState(data.site_address);
    const [siteMobile, setSiteMobile] = useState(data.phone_number);
  
    const handleEditClick = () => {
      setIsEditing(true);
    };

    const handleSaveChanges = (id) => {
      axios
        .post(base_url + "sites/update_site_by_id", {
  
          "site_id": id,
          "site_address": siteAddress,
          "phone_number": siteMobile,
          "updated_by": localStorage.getItem("login_user_name")
  
        })
        .then((res) => {
          const updated = allSitesAddresses.map(i => {
            if (i.site_id === id) {
              i.site_address = siteAddress;
              i.phone_number = siteMobile;
              i.is_selected = false;
            }
            return i;
          })
          setGetAllSites(updated)
  
        })
        .catch((err) => {
          console.log(err);
        });
  
    };
  
    const handleInputChange = (e) => {
      if (e.target.name === 'site_add') {
        setSiteAddress(e.target.value);
      } else if (e.target.name === 'phn_number') {
        setSiteMobile(e.target.value);
      }
    };


 


    return (
      <div className="card card_border">
        <div className="card-body d-flex flex-column justify-content-between">
          <div className="hosp_addr">
          <h5 className="card-title  w-100 h-50 card_title_scrool " >
                 { data.site_name}
          </h5>
            <p className="card_text_siteaddress text-secondary mb-0 ">
              {data.is_selected ? (
                <input
                  type="text"
                  // id={}
                  name="site_add"
                  className="card_input text-secondary w-100 h-50"
                  value={siteAddress}
                  onChange={handleInputChange}
                  autoFocus              
                />
              ) : (
                <span>{data.site_address}</span>
              )}
            </p>
          </div>
          <div className="card_hr"></div>

          <div className="mb-2 mt-2">
            <div className="align-self-end">
              <h3 className="card-title">{data.zone_name}</h3>
              <p className="card_text text-dark mb-0">
                {data.is_selected ? (
                  <input
                    name="phn_number"
                    // id={}
                    type="number"
                    className="card_input w-100 h-40 noSpinArrows"
                    value={siteMobile}
                    onChange={handleInputChange}
                    // autoFocus={siteMobileInputRef}
                  />
                ) : (
                  data.phone_number
                )}
              </p>
            </div>
          </div>
        </div>
        <div className="card-footer text-center ">
          <small className="text-muted">
            {moment(data.updatedAt).format("DD-MMM-YYYY")}
          </small>
          <div className="d-flex gap-3">
            <small className="b_txt C-pointer">
              {data.is_selected === true ? (
                <div className="d-flex gap-3">
                  <p
                    className="b_txt mb-0"
                    onClick={() => handleCancelEdit(data)}
                  >
                    Cancel
                  </p>
                  <p
                    className="b_txt mb-0 text-primary"
                    onClick={() => handleSaveChanges(data.site_id)}
                  >
                    Save
                  </p>
                </div>
              ) : (
                <p className="b_txt mb-0" onClick={() => handleEditCard(data)}>
                  Edit
                </p>
              )}
            </small>
          </div>
        </div>
      </div>
    );
  }
  const handleAddNewSiteBtn = () => {
    setShow(true)
    setBtnFlag(true)
  }
  const handleConfirmAction=()=>{
    setOpen(false)

  }

  const [currentPagePagination, setCurrentPagePagination] = useState(1);
  const CardsPerPage = 6;
  const indexOfLastCard = currentPagePagination * CardsPerPage;
  const indexOfFirstCard = indexOfLastCard - CardsPerPage;
  const currentCards = filteredStudies.slice(indexOfFirstCard, indexOfLastCard);

  const pagination = (pageNumber) => setCurrentPagePagination(pageNumber);
  const jumpToFirstPage = () => setCurrentPagePagination(1);
  const jumpToLastPage = () => setCurrentPagePagination(Math.ceil(filteredStudies.length / CardsPerPage));
 

  return (
    <div>
      <NavigationBar studyDropdwn={true} title={'Sites'}/>

      <div>
      {loading_flag ? (
       <div className=''>
       <img
         className="atrium_loader"
         src="/images/circle-effect-loading.gif"
         alt="Loader"

       />
     </div>
      ) : (
        <div className="main_body ">
        <div className="new_button pt-4 p-3 bg-white d-flex flex-wrap gap-2">
          <div className=" sites_dropdown">
            <Select
              width={"130px"}
              options={zone_options}
              initialValue={"All Zones"}
              onChange={handleSelectZone}
              defaultSelect={defaultSelect}
            />

            <Select
              width={"250px"}
              options={state_options}
              initialValue={"All States"}
              onChange={handleStateOptionSelect}
              defaultSelect={defaultSelect}
            />
            <Select
              width={"200px"}
              options={city_options}
              initialValue={"All Cities"}
              onChange={handleCityOptionSelect}
            />
           
          </div>
         
          <div className="d-flex">
          <input
                    type="text"
                    className="me-2"
                    value={searchText}
                    style={{ width: "280px" }}
                    placeholder="Search with Site Name"
                    onChange={handleSearchData}
                  />
            <button className="gray_btn me-2" onClick={handleClearFilters}>
              Clear All
            </button>
            <button className="orange_btn  " onClick={handleAddNewSiteBtn}>
              Add New Site
            </button>
          </div>
        </div>
        
        <div className="d-flex">
          <Offcanvas onExit={handleOnExit} show={show} onHide={handleCloseModal} placement="end">
            <Offcanvas.Header className="offcanvas_header_styl">
              <img src="./images/icons/closeIcon.svg" alt="" onClick={handleCloseModal} />
              <Offcanvas.Title>Add New Site</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="ans_offcanvas_body">
              <Select
                width={"100%"}
                label={"Select Zone"}
                options={zone_options}
                initialValue={"Select Zone"}
                onChange={handleSelectZone}
                required={"*"}
              />
              <Select
                width={"100%"}
                label={"Select state"}
                options={state_options}
                initialValue={"Select state"}
                onChange={handleStateOptionSelect}
                required={"*"}
              />

              <Select
                width={"100%"}
                label={"Select city"}
                options={city_options}
                initialValue={"Select city"}
                onChange={handleCityOptionSelect}
                required={"*"}
              />

              <div className="fields">
                <label className="d-flex justify-content-start select-label">
                  Site Name <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className="input_sitedata"
                  placeholder="Type here"
                  name="site_name"
                  onChange={handleInputeSiteDetails}
                />
              </div>

              <div className="ans_sb_main">
                <label className="d-flex justify-content-start select-label">
                  {" "}
                  Site Address <span className="text-danger">*</span>
                </label>
                <textarea
                  type="text"
                  className="input_siteAddress"
                  placeholder="Site Address"
                  name="site_add"
                  onChange={handleInputeSiteDetails}
                />
              </div>

              

              <div className="fields">
                <label className="d-flex justify-content-start select-label">
                  Site Location <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className="input_sitedata"
                  placeholder="Type here"
                  name="location"
                  onChange={handleInputeSiteDetails}
                />
              </div>

              <div className="fields">
                <label className="d-flex justify-content-start select-label">
                  Pin Code <span className="text-danger">*</span>
                </label>

                <input
                  type="number"
                  className="input_sitedata"
                  placeholder="Type here"
                  name="pin_code"
                  value={sitePinCode}
                  onChange={handleInputeSiteDetails}
                />

                {pinCodeError && <div className="text-danger">{pinCodeError}</div>}
              </div>
              <div>
                <label className="d-flex justify-content-start select-label">
                  Phone <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  value={phoneNo}
                  className="input_sitedata"
                  placeholder="Enter Phone Number"
                  name="phone_no"
                  onChange={handleInputeSiteDetails}
                />
              </div>
              
            </Offcanvas.Body>
            <div className="Newsite_buttons">
              <button className="white_btn newsite_btn" onClick={handleDiscard}>
                Discard
              </button>
              <button
                className="orange_btn newsite_btn"
                onClick={createNewSite}
                disabled={
                  !zoneId ||
                  !stateId ||
                  !newCityId ||
                  !siteName ||
                  !siteAdd ||
                  !phoneNo ||
                  ! siteLocation ||
                  !(sitePinCode && /^\d{6}$/.test(sitePinCode))
                }
              >
                Save
              </button>

            </div>
          </Offcanvas>
        </div>
      
   
        <div className="page-container">
        <div className="content-container">
        
        <div className="row">
        {currentCards.length ===0 && !filterLength? (
          <Loader />
      )  : currentCards.length > 0 ? (
          currentCards.map((card, idx) => (
            <div className="col-sm-12 col-md-6 col-lg-4 mb-3" key={card.site_id}>
              <Card data={card} />
            </div>
          ))
        )
         : (
          filterLength && <div className="text-center custom-message-container">
                    <h4 className="custom-message">No Sites based on your search criteria</h4>
          </div>
        )
        
        }
      </div>
        </div>
      </div>
      </div>
      )}
      </div>
      <PopUpModal
        handleClose={handleClosePopup}
        open={open}
        title={"Success!"}
        msg={"New Site Created Successfully"}
        close={"Close"}
        actionbtn={"Done"}
        onConfirm={handleReviewActions}
      />
      

           <div className="footer-pagination pb-3 d-flex justify-content-between">
           <div className="ps-5 ms-5 align-items-center d-flex fw-bold fs-5">{filteredStudies.length > 0 ? `Count of site: ${filteredStudies.length}` :""}</div>
           <div>
             {filteredStudies?.length>4 && <Pagination
                      jumpToFirstPage={jumpToFirstPage}
                      jumpToLastPage={jumpToLastPage}
                      currentPagePagination={currentPagePagination}
                      pagination={pagination}
                      CardsPerPage={CardsPerPage}
                      filteredStudies={filteredStudies}
                    />}
           </div>



            {/* <Paginate
               onPageChange={(number) => paginate(number)}
                previousPage={previousPage}
                nextPage={nextPage}
                pageCount={Math.ceil(filteredStudies.length / postsPerPage)}
                postsPerPage={postsPerPage}
                totalPosts={filteredStudies.length}
                currentPage={currentPage1}
                /> */}
            </div>

    </div>
  );
};

export default PMSSiteDetails;
